<template>
  <div class="stake-holder">
    <table>
      <thead>
        <tr v-if="title">
          <th colspan="3">{{ title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(stakeholder, idx) in stakeholders" :key="idx">
          <td>
            <div>{{ stakeholder.display_name }} #{{ stakeholder.commission_number }}</div>
            <div v-if="stakeholder.email">
              <font-awesome-icon icon="envelope" />
              {{ stakeholder.email }}
            </div>
          </td>
          <td v-if="stakeholder.commission_type !== 'OVERRIDE'">
            <InputField
              v-model="stakeholder.split"
              type="text"
              class="form-input form-number-input"
              picker="percent"
              @input="sendUpdateMessage(stakeholder)"
            />
          </td>
          <td v-else></td>
          <td class="remove">
            <font-awesome-icon icon="times-circle" @click="sendRemoveMessage(stakeholder)" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import InputField from '@/app/components/InputField';
export default {
  components: {
    InputField
  },
  props: {
    stakeholders: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    sendUpdateMessage(data) {
      this.$emit('update', data);
    },
    sendRemoveMessage(evt) {
      this.$emit('remove', evt);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.stake-holder {
  margin-bottom: 25px;
  table {
    table-layout: fixed;
    border-collapse: collapse;
    thead {
      border-bottom: 2px solid $row_border;
    }
    thead tr th {
      text-transform: uppercase;
      font-size: 0.7em;
      background-color: $background-level-3;
      padding: 8px 0;
    }

    thead tr.rate-header {
      th {
        &:not(:first-of-type) {
          text-align: center;
        }
        &:not(:nth-of-type(5)) {
          border-right: 1px solid $row-border;
        }
        &:last-of-type {
          border-right: 0;
        }
      }
    }

    tbody tr {
      &:nth-child(even) {
        background-color: $background-level-3;
        input {
          border: 0;
          border-left: 2px solid $background-level-3;
          border-right: 2px solid $background-level-3;
          background-color: $white;
        }
      }
      &:nth-child(odd) {
        input {
          border: 0;
          border-left: 2px solid $white;
          border-right: 2px solid $white;
          background-color: $background-level-3;
        }
      }
    }
    tbody tr td {
      padding: 8px 0;
      &:not(:nth-of-type(1)) {
        text-align: center;
      }
      &.remove {
        text-align: right;
        color: $row-border;
        padding-right: 5px;
        svg {
          &:hover {
            color: $red;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.form-input {
  border-bottom: 1px solid $blue;
  font-size: 1em;
  height: inherit;
  &:focus {
    outline: none;
  }
  &.error {
    border-bottom: 1px solid $red;
  }

  &.small {
    width: auto;
    display: inline-flex;
    margin-right: 15px;
  }

  &.form-number-input {
    width: 50px;
    border: 1px solid $mid-blue;
    display: inline-flex;
    padding: 5px 0;
    &.wide {
      width: 100px;
    }

    .icon-wrapper {
      margin-left: 3px;
      color: red;
    }
  }
}
</style>
